"use client"

import { FiMoon, FiSun } from "react-icons/fi"
import { Switch } from "@/components/ui-lab/switch"
import { useTheme } from "./ThemeProvider"

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme()
  const isDark = theme === "dark"

  return (
    <Switch
      checked={isDark}
      onCheckedChange={toggleTheme}
      aria-label="Toggle dark mode"
      thumbContent={isDark ? <FiMoon className="h-3 w-3" /> : <FiSun className="h-3 w-3" />}
    />
  )
}
